import React from "react";
import { Card, Row, Col, Table, Button } from "react-bootstrap";

export default function InventoryOverview() {

  // =========================
  // SAMPLE DATA
  // =========================

  const summary = {
    totalItems: 245,
    reusable: 80,
    consumable: 165,
    lowStock: 12,
    totalValue: 475800,
  };

  const categories = [
    { name: "Books", total: 120, inStock: 110, low: 8, value: 180000 },
    { name: "Uniform", total: 60, inStock: 50, low: 5, value: 120000 },
    { name: "Sports", total: 40, inStock: 38, low: 2, value: 95000 },
    { name: "Lab Equipment", total: 25, inStock: 22, low: 3, value: 80800 },
  ];

  const lowStockItems = [
    { name: "Chemistry Lab Coat", category: "Lab", qty: 3, min: 10 },
    { name: "Football", category: "Sports", qty: 2, min: 8 },
    { name: "Class 5 Textbook", category: "Books", qty: 5, min: 15 },
  ];

  const recentActivity = [
    { date: "21 Feb 2026", item: "Math Book", type: "Issued", qty: 10, by: "Admin" },
    { date: "20 Feb 2026", item: "Football", type: "Added", qty: 5, by: "Store" },
    { date: "19 Feb 2026", item: "Uniform Shirt", type: "Issued", qty: 12, by: "Clerk" },
  ];

  return (
    <div className="container-fluid">

      <h3 className="mb-4">Inventory Overview</h3>

      {/* =========================
         1️⃣ SUMMARY CARDS
      ========================== */}
      <Row className="mb-4">
        <Col md={2}>
          <Card className="p-3 text-center">
            <h6>Total Items</h6>
            <h4>{summary.totalItems}</h4>
          </Card>
        </Col>

        <Col md={2}>
          <Card className="p-3 text-center">
            <h6>Reusable</h6>
            <h4>{summary.reusable}</h4>
          </Card>
        </Col>

        <Col md={2}>
          <Card className="p-3 text-center">
            <h6>Consumable</h6>
            <h4>{summary.consumable}</h4>
          </Card>
        </Col>

        <Col md={2}>
          <Card className="p-3 text-center text-danger">
            <h6>Low Stock</h6>
            <h4>{summary.lowStock}</h4>
          </Card>
        </Col>

        <Col md={4}>
          <Card className="p-3 text-center bg-light">
            <h6>Total Value</h6>
            <h4>₹{summary.totalValue.toLocaleString()}</h4>
          </Card>
        </Col>
      </Row>

      {/* =========================
         2️⃣ CATEGORY SUMMARY
      ========================== */}
      <Card className="mb-4 p-3">
        <h5>Category Summary</h5>
        <Table bordered hover responsive>
          <thead>
            <tr>
              <th>Category</th>
              <th>Total Items</th>
              <th>In Stock</th>
              <th>Low Stock</th>
              <th>Value</th>
            </tr>
          </thead>
          <tbody>
            {categories.map((cat, i) => (
              <tr key={i}>
                <td>{cat.name}</td>
                <td>{cat.total}</td>
                <td>{cat.inStock}</td>
                <td className="text-danger">{cat.low}</td>
                <td>₹{cat.value.toLocaleString()}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </Card>

      {/* =========================
         3️⃣ LOW STOCK ALERT
      ========================== */}
      <Card className="mb-4 p-3 border-danger">
        <h5 className="text-danger">Low Stock Alerts</h5>
        <Table bordered hover responsive>
          <thead>
            <tr>
              <th>Item</th>
              <th>Category</th>
              <th>Current Qty</th>
              <th>Minimum Required</th>
            </tr>
          </thead>
          <tbody>
            {lowStockItems.map((item, i) => (
              <tr key={i}>
                <td>{item.name}</td>
                <td>{item.category}</td>
                <td className="text-danger">{item.qty}</td>
                <td>{item.min}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </Card>

      {/* =========================
         4️⃣ RECENT ACTIVITY
      ========================== */}
      <Card className="mb-4 p-3">
        <h5>Recent Activity</h5>
        <Table bordered hover responsive>
          <thead>
            <tr>
              <th>Date</th>
              <th>Item</th>
              <th>Type</th>
              <th>Qty</th>
              <th>By</th>
            </tr>
          </thead>
          <tbody>
            {recentActivity.map((act, i) => (
              <tr key={i}>
                <td>{act.date}</td>
                <td>{act.item}</td>
                <td>{act.type}</td>
                <td>{act.qty}</td>
                <td>{act.by}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </Card>

      {/* =========================
         5️⃣ QUICK ACTIONS
      ========================== */}
      <Card className="p-3">
        <h5>Quick Actions</h5>
        <div className="d-flex gap-2 flex-wrap">
          <Button variant="primary">Add New Item</Button>
          <Button variant="success">Add Stock</Button>
          <Button variant="warning">Issue Item</Button>
          <Button variant="info">Return Item</Button>
          <Button variant="secondary">Export Report</Button>
        </div>
      </Card>

    </div>
  );
}